
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 36.049 41.199"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 7104","d":"M24.462 9.012a1.288 1.288 0 010 2.575H11.587a1.288 1.288 0 110-2.575zm11.587 24.635c0 6.943-5.482 7.551-12.985 7.551-1.6 0-3.291-.028-5.039-.028s-3.44.028-5.041.028C5.484 41.198 0 40.587 0 33.647c0-6.261 4.463-16.121 10.841-20.773h14.365c6.38 4.653 10.843 14.512 10.843 20.773zm-2.575 0c0-5.26-3.722-13.812-9.143-18.2H11.716c-5.419 4.386-9.141 12.938-9.141 18.2 0 3.734 1.5 4.976 10.409 4.976.776 0 1.572-.008 2.387-.013.866-.008 1.753-.015 2.654-.015s1.788.008 2.653.015c.814.006 1.611.013 2.386.013 8.906.001 10.412-1.241 10.412-4.976zM7.725.586A2.672 2.672 0 019.508 0c2.79 0 6.719 2.842 8.409 2.842h.216c1.689 0 5.62-2.842 8.408-2.842a2.675 2.675 0 011.783.586c2.575 2.172-3.118 7.139-3.118 7.139H10.842S5.15 2.758 7.725.586zm12 4.564h4.462a12.355 12.355 0 002.015-2.55 16.874 16.874 0 00-3.759 1.418 21.244 21.244 0 01-2.718 1.132zM9.847 2.6a12.276 12.276 0 002.013 2.55h4.463a21.242 21.242 0 01-2.717-1.132A16.853 16.853 0 009.847 2.6z","fill":"#3d9ed3"}})])
          )
        }
      }
    